module.exports = __webpack_public_path__ + "static/media/featured-members.63d7d401.svg";